import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { InfoContext } from "../providers/InfosContextProvider";

const CookiesPolicy = () => {
  const { texts } = useContext(InfoContext);

  useEffect(() => {
    const pageTitle = texts?.cookiesPolicy?.title || "Política de Cookies";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);

  const renderTextWithLinks = (text) => {
    return text.split("\n").map((paragraph, index) => {
      if (!paragraph.trim()) return null;

      const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
      const parts = paragraph.split(urlRegex);

      const formattedParagraph = parts.map((part, i) => {
        if (part.match(urlRegex)) {
          const href = part.startsWith("http") ? part : `https://${part}`;
          return (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none fw-bold legal-link"
            >
              {part}
            </a>
          );
        }
        return part;
      });

      const isHeading = /^\d+\.\s/.test(paragraph);

      if (isHeading) {
        return (
          <h5
            key={index}
            className="mt-4 mb-3 fw-bold"
            style={{ color: "#333" }}
          >
            {formattedParagraph}
          </h5>
        );
      }

      return (
        <p
          key={index}
          className="mb-3 lh-lg text-secondary"
          style={{ fontSize: "1.05rem", textAlign: "justify" }}
        >
          {formattedParagraph}
        </p>
      );
    });
  };

  return (
    <div>
      <Header />
      <Container className="sell-property">
        <div
          className="contact-card p-md-5 p-4 shadow-sm bg-white rounded-3"
          style={{ borderTop: "4px solid #a02020" }}
        >
          <h2
            className="mb-4 fw-bold"
            style={{
              color: "#333",
              borderBottom: "2px solid #f0f0f0",
              paddingBottom: "15px",
            }}
          >
            {texts.cookiesPolicy.title}
          </h2>
          <div className="whistleblowing-text">
            {renderTextWithLinks(texts.cookiesPolicy.text)}
          </div>
        </div>
      </Container>
      <div className="div-footer">
        <Footer />
      </div>
    </div>
  );
};

export default CookiesPolicy;
